import { hasAudit, hasInfiltro } from "../hexagone/VisibilityHelpers";
import { queryCollection } from "../models/DataFunctions";

export const getAllVisibleDocumentxxs = async (orgData) => {
  let banque_docs = await getMyBricksDocumentxxs(orgData);
  let custom_docs = await getCustomDocumentxxs(orgData);
  let docs = banque_docs.concat(custom_docs);
  return docs;
};

export const getMyBricksDocumentxxs = async (orgData) => {
  let docs = [];
  if (hasInfiltro(orgData)) {
    docs = await getInfiltroDocumentxxs();
  }
  if (hasAudit(orgData)) {
    let audit_docs = await getAuditDocumentxxs();
    docs = docs.concat(audit_docs);
  }
  return docs;
};

const getInfiltroDocumentxxs = async () => {
  return await getAllTypeDocumentxxs("infiltro");
};
const getAuditDocumentxxs = async () => {
  return await getAllTypeDocumentxxs("audit");
};

const getAllTypeDocumentxxs = async (type) => {
  let banque_docs = await queryCollection("documentxx", [
    {
      field: "custom",
      operator: "==",
      value: false,
    },
    {
      field: "type",
      operator: "==",
      value: type,
    },
  ]);
  return banque_docs;
};

const getCustomDocumentxxs = async (orgData) => {
  let docs = await queryCollection("documentxx", [
    {
      field: "custom",
      operator: "==",
      value: true,
    },
    {
      field: "org_id",
      operator: "==",
      value: orgData.id,
    },
  ]);
  return docs;
};
